import { defineStore } from "pinia";
interface utmInfo {
    utm_source: string;
    utm_medium: string;
    utm_campaign: string;
    utm_term: string;
    utm_content: string;
}
const globalStore = defineStore("digiCounsel:global", {
    state: () => {
        return {
            isRefreshing: false as boolean,
        };
    },
    actions: {
        setRefreshing(isRefreshing: boolean) {
            this.isRefreshing = isRefreshing;
        },
    },
});

export default globalStore;
